var map = {
	"./symbol_0.png": 39873,
	"./symbol_1.png": 55256,
	"./symbol_10.png": 76234,
	"./symbol_11.png": 8147,
	"./symbol_12.png": 96184,
	"./symbol_13.png": 17313,
	"./symbol_14.png": 18830,
	"./symbol_15.png": 18327,
	"./symbol_16.png": 10748,
	"./symbol_17.png": 46661,
	"./symbol_18.png": 25282,
	"./symbol_19.png": 15787,
	"./symbol_2.png": 29747,
	"./symbol_3.png": 90890,
	"./symbol_4.png": 75557,
	"./symbol_5.png": 46140,
	"./symbol_6.png": 46775,
	"./symbol_7.png": 87406,
	"./symbol_8.png": 76793,
	"./symbol_9.png": 79888
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26159;